<template>
  <callout
    border-color-hex="#B5C3BC"
    borderColor="#B5C3BC"
    apply-border-top
    controlled
    has-gradient
    has-border
    has-toggle
    :opened="isExpanded"
    @click:open="isExpanded = !isExpanded"
  >
    <div class="row py-2">
      <div
        class="col-12 col-md d-flex align-items-center border-right mr-0 mr-md-5"
      >
        <p class="font-18 font-weight-bold week mb-0">{{ item.weekName }}</p>
      </div>
      <div class="col-12 col-md-7">
        <div class="row">
          <div class="col-12 col-md">
            <label class="text-gray font-14">Estatus:</label>
            <p class="mb-0">
              <i class="fas fa-circle font-12 mr-2" :class="status.color"></i>
              <span class="font-14 text-description">{{ status.text }}</span>
            </p>
          </div>
          <div class="col-12 col-md">
            <label class="text-gray font-14">Progreso Académico:</label>
            <p class="font-14 text-description mb-0">
              {{ value }}
            </p>
          </div>
          <div class="col-12 col-md">
            <label class="text-gray font-14">Fecha de Sometido:</label>
            <p class="font-14 text-description mb-0">
              {{ item.submittedDate | date }}
            </p>
          </div>
          <div class="col-12 col-md">
            <label class="text-gray font-14">Fecha de Discusión:</label>
            <p class="font-14 text-description mb-0">
              {{ item.discussionDate | date }}
            </p>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-3 d-flex justify-content-end">
        <DropDown
          v-if="showActions"
          class="actions-dropdown pt-2 pr-4"
          :items="getMenuItems"
          normal-size
          :always-show-dropdown="true"
        />
      </div>
    </div>
    <template #edition>
      <div class="bg-gray p-2">
        <academic-progress-amend
          v-if="isAmendType"
          @cancel="onCancel()"
          @saved="onSaveAmend()"
          :academic-progress-id="item.academicProgressId"
        ></academic-progress-amend>
        <academic-progress-view-amend
          v-if="isViewAmendType"
          :items="item.amends"
          :week-name="item.weekName"
          :item="item"
          @close="isExpanded = false"
        ></academic-progress-view-amend>
        <academic-progress-discussion
          v-if="isDiscussionType"
          @cancel="onCancel()"
          @saved="onSaveDiscussion()"
          :academic-progress-id="item.academicProgressId"
          :minDate="new Date(item.openingDate)"
        />
        <replace-discussion-document
          v-if="isDiscussionReplacement"
          @cancel="onCancel()"
          @saved="onDocumentReplaced()"
          :item="item"
        />
        <academic-progress-discussion-history
          v-if="isHistoryType"
          :history="item.history"
          :has-more-history="item.hasMoreHistory"
          @load="onLoadHistory"
        />
        <academic-progress-modify-discussion-date
          v-if="isModifyDiscussionDateType"
          @cancel="onCancel()"
          @saved="onModifyDiscussionDate()"
          :academic-progress-id="item.academicProgressId"
          :minDate="new Date(item.openingDate)"
        />
      </div>
    </template>
  </callout>
</template>

<script>
import Callout from 'custom-callout';
import DropDown from 'dropdown';
import AcademicProgressAmend from './AcademicProgressAmend.vue';
import AcademicProgressViewAmend from './AcademicProgressViewAmend.vue';
import AcademicProgressDiscussion from './AcademicProgressDiscussion.vue';
import AcademicProgressDiscussionHistory from './AcademicProgressDiscussionHistory.vue';
import AcademicProgressModifyDiscussionDate from './AcademicProgressModifyDiscussionDate.vue';
import ReplaceDiscussionDocument from './ReplaceDiscussionDocument.vue';
import { pieAcademicProgress } from '@/utils/constants/pei/progress-report-educational-services/pieAcademicProgress';
import { actionTypes } from '@/utils/constants/pei/progress-report-educational-services/actionTypes';
import store from '@/store/index';
export default {
  name: 'AdditionalProgressInformationRow',
  components: {
    Callout,
    DropDown,
    AcademicProgressAmend,
    AcademicProgressViewAmend,
    AcademicProgressDiscussion,
    ReplaceDiscussionDocument,
    AcademicProgressDiscussionHistory,
    AcademicProgressModifyDiscussionDate,
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    isExpanded: false,
    actionType: null,
    historySize: 5,
  }),
  computed: {
    isAmendType() {
      return this.actionType == actionTypes.Amend;
    },
    isViewAmendType() {
      return this.actionType == actionTypes.ViewAmend;
    },
    isDiscussionType() {
      return this.actionType == actionTypes.Discussion;
    },
    isDiscussionReplacement() {
      return this.actionType == actionTypes.ReplaceDiscussion;
    },
    showActions() {
      return (
        this.item.statusId != pieAcademicProgress.Unavailable &&
        this.item.statusId != pieAcademicProgress.NotApply
      );
    },
    isHistoryType() {
      return this.actionType == actionTypes.History;
    },
    isModifyDiscussionDateType() {
      return this.actionType == actionTypes.ModifyDiscussionDate;
    },
    historyPermission() {
      return store.getters.HasPermission('pei.history.document.week');
    },
    showDocumentWeekPermission() {
      return store.getters.HasPermission('pei.show.document.week');
    },
    showProgressWeekPermission() {
      return store.getters.HasPermission('pei.show.week.progress');
    },
    showPrintPermission() {
      return store.getters.HasPermission('pei.show.print.progress');
    },
    showButtonToReplacePermission() {
      return store.getters.HasPermission('pei.show.replace.document');
    },
    getMenuItems() {
      let result = [];
      const statuses = [
        pieAcademicProgress.Submitted,
        pieAcademicProgress.Discussed,
      ];
      if (this.item.academicProgressId && this.historyPermission) {
        result.push({
          label: 'Historial de Semana',
          icon: 'fas fa-calendar text-green',
          click: () => this.viewHistory(),
        });
      }
      if (
        statuses.includes(this.item.statusId) &&
        this.showProgressWeekPermission
      ) {
        result.push({
          label: `Ver ${this.item.weekName}`,
          icon: 'fas fa-file-search text-green',
          click: () => this.$emit('view', this.item),
        });
      }
      if (statuses.includes(this.item.statusId) && this.showPrintPermission) {
        result.push({
          label: `Imprimir Informe de Progreso`,
          icon: 'fas fa-print text-green',
          click: () => {
            this.$emit('download', this.item.academicProgressId);
          },
        });
      }
      if (
        this.item.statusId === pieAcademicProgress.Pending &&
        this.showDocumentWeekPermission
      ) {
        result.push({
          label: `Documentar ${this.item.weekName}`,
          icon: 'fas fa-edit text-green',
          class: 'border-top',
          click: () => {
            this.$emit('edit', this.item);
          },
        });
      }
      if (this.item.amends.length > 0) {
        result.push({
          label: `Ver Enmendados`,
          icon: 'fas fa-undo text-green',
          class: 'border-top',
          click: () => {
            this.viewAmend();
          },
        });
      }
      if (this.item.statusId === pieAcademicProgress.Submitted) {
        result.push(
          {
            label: `Documentar Discusión de IP`,
            icon: 'fas fa-file-exclamation text-green',
            class: 'border-top',
            click: () => {
              this.discuss();
            },
          },
          {
            label: `Enmendar`,
            icon: 'fas fa-copy text-green',
            click: () => {
              this.amend();
            },
          }
        );
      }
      if (this.item.statusId === pieAcademicProgress.Discussed) {
        result.push({
          label: 'Modificar Fecha de Discusión',
          icon: 'fas fa-calendar-alt text-green',
          click: () => {
            this.modifyDiscussionDate();
          },
        });

        if (
          store.getters.HasPermission(
            'pei.academicprogress.downloaddiscussiondocument'
          )
        ) {
          result.push({
            label: `Descargar documento de Discusión`,
            icon: 'fas fa-file-download text-green',
            click: () => {
              this.$emit('download-discussion', this.item.documentId);
            },
          });
        }
        if (
          store.getters.HasPermission(
            'pei.academicprogress.replacediscussiondocument'
          ) &&
          this.showButtonToReplacePermission
        ) {
          result.push({
            label: `Reemplazar Documento de Discusión`,
            icon: 'fas fa-undo text-green',
            click: () => {
              this.replaceDiscuss();
            },
          });
        }
      }

      return result;
    },
    status() {
      switch (this.item.statusId) {
        case pieAcademicProgress.Unavailable:
          return {
            color: 'circle-unavailable',
            text: 'No Disponible',
          };
        case pieAcademicProgress.Pending:
          return {
            color: 'circle-pending',
            text: 'Pendiente',
          };
        case pieAcademicProgress.Submitted:
          return {
            color: 'circle-submitted',
            text: 'Sometido',
          };
        case pieAcademicProgress.Discussed:
          return {
            color: 'circle-discussed',
            text: 'Discutido',
          };
        case pieAcademicProgress.NotApply:
          return {
            color: 'circle-not-apply',
            text: 'No Aplica (N/A)',
          };
        default:
          return {
            color: 'circle-unavailable',
            text: 'No Disponible',
          };
      }
    },
    value() {
      return this.item.isNt
        ? 'NT'
        : this.item.status == 6
        ? 'N/A'
        : this.percentage(this.item.progress);
    },
    percentage() {
      return (value) => (value === 0 ? '0%' : value ? `${value}%` : '-');
    },
  },
  methods: {
    modifyDiscussionDate() {
      this.actionType = actionTypes.ModifyDiscussionDate;
      this.isExpanded = true;
    },
    onModifyDiscussionDate() {
      this.actionType = null;
      this.isExpanded = false;
      this.$emit('refresh-additional-information');
    },
    amend() {
      this.actionType = actionTypes.Amend;
      this.isExpanded = true;
    },
    viewAmend() {
      this.actionType = actionTypes.ViewAmend;
      this.isExpanded = true;
    },
    discuss() {
      this.actionType = actionTypes.Discussion;
      this.isExpanded = true;
    },
    replaceDiscuss() {
      this.actionType = actionTypes.ReplaceDiscussion;
      this.isExpanded = !this.isExpanded;
    },
    onCancel() {
      this.actionType = null;
      this.isExpanded = false;
    },
    onSaveAmend() {
      this.actionType = null;
      this.isExpanded = false;
      this.$emit('saved');
    },
    onDocumentReplaced() {
      this.actionType = null;
      this.isExpanded = false;
      this.$emit('save-discussion');
    },
    onSaveDiscussion() {
      this.actionType = null;
      this.isExpanded = false;
      this.$emit('save-discussion');
    },
    viewHistory() {
      this.actionType = actionTypes.History;
      this.isExpanded = true;
    },
    onLoadHistory(size) {
      this.historySize = size ? this.historySize + size : 5;
      this.$emit('load-history', this.item, this.historySize);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables/_colors.scss';

.week {
  color: map-get($colors, 'gray-12');
}

.circle-unavailable,
.circle-not-apply {
  color: map-get($colors, 'gray-2');
}
.circle-pending {
  color: map-get($colors, 'primary-16');
}
.circle-submitted {
  color: #fae76f;
}
.circle-discussed {
  color: map-get($colors, 'green-light');
}
label {
  font-weight: normal !important;
}
.bg-gray {
  background-color: #f7f7f7 !important;
}
</style>
